import $ from "jquery";
require('./quickBtnGroup.less');
import {isPresent} from "../../utilities/general";

//options = multi = true,
export default function QuickBtnGroup(quickBtnGroup, options={}){
  const self = this;
  self.options = options;

  self.init = function(){
    bindElements();
    distributeBtnWidthEqually();
    activateInitialKey();
    handleDisable();
  }

  self.activateBtnViaKey = function(btnKey){
    const btn = getBtnViaKey(btnKey);
    deactivateAllBtnEls();
    activateBtnEl(btn);
    updateHiddenInputToReflectBtn(btn);
    btn.trigger('click');
  }

  function bindElements(){
    getBtns().on('click', onBtnClick);
  }

  function onBtnClick(e){
    e.preventDefault();
    if(isAllDisabled()){
      return;
    }

    const btn = $(e.target);
    const btnKey = btn.data('qb-key');

    self.options.onBtnClick && self.options.onBtnClick({btn, btnKey});
    if(self.options.manualActivation){
      return;
    }
    let canNav = true;
    canNav = self.options.shouldActivateBtn && self.options.shouldActivateBtn({btn, btnKey});
    if(canNav !== false && options.multi){
      checkForActiveMulti(btn);
    }
    else if(canNav !== false){
      deactivateAllBtnEls();
      activateBtnEl(btn);
      updateHiddenInputToReflectBtn(btn);
      self.options.didActivateBtn && self.options.didActivateBtn({btn, btnKey});
    }
  }

  self.getActiveBtnKey = function(){
    return getHiddenInput().val();
  }

  function checkForActiveMulti(btn){
    if(btn.hasClass('active')){
      btn.removeClass('active');
      updateHiddenInputToReflectBtn(btn);
    }
    else{
      activateBtnEl(btn);
      updateHiddenInputToReflectBtn(btn);
      self.options.didActivateBtn && self.options.didActivateBtn({btn, btnKey});
    }
  }

  function activateInitialKey(){
    const {initialActiveKey} = self.options;
    let activeBtns = $();

    if(initialActiveKey){
      activeBtns = getBtnViaKey(initialActiveKey);
    }
    else if(getActiveBtnsFromClass().length){
      activeBtns = getActiveBtnsFromClass();
    }

    if(activeBtns.length){
      deactivateAllBtnEls();
      activateBtnEl(activeBtns);
      updateHiddenInputToReflectBtn(activeBtns);
    }
  }

  function updateHiddenInputToReflectBtn(btn){
    let btnKey = "";
    if(options.multi){
      const btnGroup = btn.closest(".multi-btn-group");
      $.each(btnGroup.find('.active'), function(i, v){
        btnKey +=$(v).data("qbKey") + ",";
      });
      btnKey = btnKey.slice(0,-1);
     }
    else{
      btnKey = btn.data('qb-key');
    }
      const hiddenInput = getHiddenInput();
      hiddenInput.val(btnKey);
      hiddenInput.trigger("change");
  }

  function handleDisable(){
    if(isAllDisabled()){
      getBtns().addClass("disabled");
    }
  }

  function isAllDisabled(){
    return options.disableAll;
  }

  function distributeBtnWidthEqually(){
    if(self.options.distributeWidth){
      const tl = totalBtns();
      const perc = 100/tl;
      getBtns().css({width: `${perc}%`});
    }
  }

  function getBtnViaKey(btnKey){
    return getBtns().filter(function(){
      return $(this).data('qb-key') === btnKey;
    });
  }

  function getBtns(){
    return quickBtnGroup.find('.q-btn');
  }

  function totalBtns(){
    return getBtns().length;
  }

  function getActiveBtnsFromClass(){
    return getBtns().filter(".active");
  }

  function deactivateAllBtnEls(){
    getBtns().removeClass('active');
  }
  function activateBtnEl(btn){
    btn.addClass('active');
  }
  function getHiddenInput(){
    return quickBtnGroup.find(".quick-btn-group-hidden-input");
  }
}



// WEBPACK FOOTER //
// ./src/components/QuickBtnGroup/QuickBtnGroup.js